module.exports = __webpack_public_path__ + "static/media/building.f07503eb.jpeg";